import { createSelector } from '@reduxjs/toolkit';
import { eq, flow, get, orderBy } from 'lodash/fp';
import { user } from '@/slices/user';
import { type RootState } from '@/store';

export const members = ({ members: { members } }: RootState) => members;
export const roleOptions = ({ members: { roleOptions } }: RootState) =>
  roleOptions;
export const propertyId = (_: any, { propertyId }: { propertyId: string }) =>
  propertyId;

export const membersByPropertyId = createSelector(
  members,
  propertyId,
  (members, propertyId) => members[propertyId],
);

export const sortedMembersByPropertyId = createSelector(
  membersByPropertyId,
  user,
  (members, user) => {
    if (!members) return undefined;

    return orderBy(flow(get('user_id'), eq(user!.id)), 'desc', members);
  },
);

export const memberCountByPropertyId = createSelector(
  sortedMembersByPropertyId,
  (members) => members?.length || 0,
);
